module.exports = __webpack_public_path__ + "static/img/yhlogo.d6511e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yhlogo.jpg
// module id = WcIb
// module chunks = 40